import isBlank from "@sedan-utils/is-blank";
export class TopicService {
    constructor(meStore, authStore) {
        this.meStore = meStore;
        this.authStore = authStore;
        this.meStore = meStore;
        this.authStore = authStore;
    }
    async generateTopic(topicInfo, topicType) {
        const { templateId, edgeId, sourceNodeId } = topicInfo || {};
        const me = await this.meStore.get();
        const id = me.id ?? this.authStore.state.guestToken;
        const wsuid = isBlank(templateId) ? "" : templateId + "_";
        const nodeid = isBlank(sourceNodeId) ? "" : "_nodeid_" + sourceNodeId;
        return `/studios/${id}/wsuid_${wsuid}${edgeId}/${topicType}/${Date.now()}${nodeid}`;
    }
}
